import React, { useEffect, useRef, useState } from "react";
import "./header.scss";
import "./BurgerMenu.scss";
import HeaderInner from "./HeaderInner";

const Header = ({}) => {
  const headerEl = useRef(null);
  const headerElFk = useRef(null);

  const [headerFixed, setHeaderFixed] = useState(false);
  const [headerAppear, setHeaderAppear] = useState(false);

  const [heightEl, setHeightEl] = useState("0px");

  const scrollObserver = ([entry]) => {
    setHeaderFixed(!entry.isIntersecting);
  };

  const getHeightInner = () => {
    setHeightEl(headerEl.current?.getBoundingClientRect()?.height + "px");
  };

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (window.matchMedia("(max-width: 990px)").matches) {
      window.onscroll = () => {
        if (window.scrollY > 10) {
          setHeaderFixed(true);
        } else {
          setHeaderFixed(false);
        }
      };

      return () => {
        window.onscroll = () => {};
      };
    } else {
      const observer = new IntersectionObserver(scrollObserver, {
        threshold: [0.1],
      });

      if (headerEl.current) {
        getHeightInner();
        window.onresize = () => getHeightInner();

        observer.observe(headerElFk.current);
      }
      return () => {
        observer.disconnect();
      };
    }
  }, [headerFixed]);

  return (
    <div className="header-fk" style={{ height: heightEl }} ref={headerElFk}>
      <HeaderInner
        isFixed={headerFixed}
        headerEl={headerEl}
        headerAppear={headerAppear}
      />
    </div>
  );
};

export default Header;
